import { EasmScanConfigurationAssetGridWebComponent } from './component/EasmScanConfigurationAssetGridWebComponent';
import { WEB_COMPONENT_EASM_SCAN_CONFIGURATION_ASSET_GRID } from '../../../webcomponents.constants';

export { EasmScanConfigurationAssetGridWebComponent };

window.customElements.define(
  WEB_COMPONENT_EASM_SCAN_CONFIGURATION_ASSET_GRID,
  EasmScanConfigurationAssetGridWebComponent
);
